import 'bootstrap/dist/css/bootstrap.css';
import { InputConfigProvider } from 'hrst-components';
import 'hrst-components/styles.css';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import ReactDOM from 'react-dom/client';
import { pdfjs } from 'react-pdf/dist/esm/entry.webpack';
import '../src/scss/styles.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <InputConfigProvider
        value={{ displayFormat: 'HH:mm - DD/MM/YYYY', dataSeparator: ',' }}
    >
        <App />
    </InputConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
